import '@lottiefiles/dotlottie-wc';

const initialize = () => {

    $('dotlottie-wc').each(function() {
        const element = this;
        const dl = element.dotLottie;

        dl.addEventListener('load', () => {
            dl.setFrame(dl.totalFrames);
            dl.setRenderConfig({
                ...dl.renderConfig,
                freezeOnOffscreen: false,
                autoResize: true,
            });
        });

        element.addEventListener('mouseover', () => {
            dl.setFrame(0);
            dl.play();
        });
    });
};

export default {
    initialize,
};

